var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import CopySvg from './copy-03.icon.svg';
export const CopyIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: CopySvg });
};
_react_refresh_temp_1 = CopyIcon;
$RefreshReg$(_react_refresh_temp_1, "CopyIcon");
